import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import XIcon from '@/components/svg-components/X.vue';
import useI18n from '@/mixins/useI18n';
import { FeaturedTeamMemberWithBio } from '../teamMembers.types';


export default /*#__PURE__*/_defineComponent({
  __name: 'TeamBioPopup',
  props: {
    teamMember: null
  },
  emits: ['close'],
  setup(__props: any) {

const props = __props as {
  teamMember: FeaturedTeamMemberWithBio;
};





const { t } = useI18n();

const bioText = computed(() => (
  props.teamMember.bio?.i18nKey
    ? t(props.teamMember.bio.i18nKey).toString()
    : ''
));

return { __sfc: true,props, t, bioText, BCXMarkdown, XIcon }
}

})